import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
  TelegramIcon,
} from "react-share";
import "./BlogDetails.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BlogDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { title } = useParams();
  const [post, setPost] = useState(location.state?.post ?? null);
  const [loading, setLoading] = useState(!location.state?.post);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchPost = async () => {
      if (location.state?.post) {
        setPost(location.state.post);
        setLoading(false);
        return;
      }

      if (!title) {
        setLoading(false);
        setError("Blog post not found.");
        return;
      }

      try {
        setLoading(true);
        const slug = encodeURIComponent(title);
        const res = await fetch(`${BASE_URL}/blog/posts/slugs/${slug}`);

        if (!res.ok) {
          const fallback = await fetch(`${BASE_URL}/blog/posts/${slug}`);
          if (!fallback.ok) throw new Error("Missing blog post");
          const fallbackPayload = await fallback.json();
          const fallbackPost = fallbackPayload?.data ?? fallbackPayload;
          setPost(fallbackPost);
          return;
        }

        const payload = await res.json();
        const postData = payload?.data ?? payload;
        setPost(postData);
      } catch (err) {
        console.error(err);
        setError("Blog post not found.");
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [location.state, title]);

  const currentUrl = window.location.href;
  const tags = Array.isArray(post?.tags) ? post.tags : [];
  const categories = Array.isArray(post?.categories) ? post.categories : [];

  if (loading) {
    return (
      <div className="loading-spinner-wrapper">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!post || error) {
    return (
      <div className="error-container">
        <p>{error || "Blog post not found."}</p>
        <button onClick={() => navigate("/blog")} className="back-button">
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="details-container">
      <button
        onClick={() => navigate("/blog")}
        className="back-button top-left"
      >
        ← Back to Posts
      </button>
      <h1 className="details-title">{post.title}</h1>
      <img
        src={post.coverImageUrl}
        alt={post.title}
        className="details-image"
      />
      <p className="details-excerpt">{post.excerpt}</p>
      <div className="details-content">{post.content}</div>

      <div className="details-meta">
        <p>
          <strong>Tags:</strong> {tags.join(", ")}
        </p>
        <p>
          <strong>Categories:</strong> {categories.join(", ")}
        </p>
      </div>
      <div className="share-buttons">
        <p className="share-title">Share this post:</p>
        <div className="icon-group">
          <FacebookShareButton url={currentUrl} quote={post.title}>
            <FacebookIcon size={40} round />
          </FacebookShareButton>
          <TwitterShareButton url={currentUrl} title={post.title}>
            <TwitterIcon size={40} round />
          </TwitterShareButton>
          <WhatsappShareButton url={currentUrl} title={post.title}>
            <WhatsappIcon size={40} round />
          </WhatsappShareButton>
          <LinkedinShareButton url={currentUrl} title={post.title}>
            <LinkedinIcon size={40} round />
          </LinkedinShareButton>
          <TelegramShareButton url={currentUrl} title={post.title}>
            <TelegramIcon size={40} round />
          </TelegramShareButton>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
